module.exports = __webpack_public_path__ + "img/my.baa6cc3a.svg";